import { parsePayload, encodePayload } from './payload-helpers';
import { parseURLSearchParams } from './url-params';
import { pushState } from './url-utils';
import Config from '../config-manager';

export interface PayloadState {
  isPresent: boolean;
  isValid: boolean;
  payload: Record<string, any>;
}

export const parsePayloadFromURL = (): PayloadState => {
  const params = parseURLSearchParams();
  let payload = {};
  let isPresent = false;
  let isValid = true;

  try {
    const payloadParamName = Config.get<string>('url_search_params.payload');
    if (payloadParamName in params) {
      isPresent = true;
      const encoded = params[payloadParamName];
      payload = parsePayload(encoded);
    }
  } catch (err) {
    console.error(err);
    isValid = false;
  }

  return {
    isPresent,
    isValid,
    payload,
  };
};

export const pushPayloadToHistory = (payload?: Record<string, any>, path = window.location.pathname): void => {
  const params = parseURLSearchParams();
  if (!payload) {
    delete params[Config.get<string>('url_search_params.payload')];
  } else {
    params[Config.get<string>('url_search_params.payload')] = encodePayload(payload);
  }
  pushState(path, params);
};
